@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.steps {
  display: flex;
  align-items: center;
  gap: 8px;

  .step {
    display: flex;
    align-items: center;
    gap: 8px;

    &Number {
      padding: 5px 9px;
      color: map.get(core.$colors, simpleWhite);
      background-color: map.get(core.$colors, middleGrey);
      border-radius: 50%;

      &Active {
        background-color: map.get(core.$colors, accentOrange);
      }

      &Passed {
        background-color: map.get(core.$colors, secondaryBlue);
      }

      &Error {
        background-color: map.get(core.$colors, error);
        outline: 1px solid map.get(core.$colors, simpleWhite);
        outline-offset: -3px;
      }
    }

    &:not(:last-child) {
      .stepDivider {
        background-color: map.get(core.$colors, middleGrey);
        width: 24px;
        height: 1px;
      }
    }
  }
}
